"use client";

import _createForOfIteratorHelper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { batch, createStore, init, setup, throwOnConflictingProps } from "./BCALMBPZ.js";
import { chain, defaultValue } from "./PBFD2E7P.js";
import { getDocument, sortBasedOnDOMPosition } from "./DTR5TSDJ.js";
import { __spreadProps, __spreadValues } from "./3YLGPPWQ.js"; // src/collection/collection-store.ts

function getCommonParent(items) {
  var _a;

  var firstItem = items.find(function (item) {
    return !!item.element;
  });

  var lastItem = _toConsumableArray(items).reverse().find(function (item) {
    return !!item.element;
  });

  var parentElement = (_a = firstItem == null ? void 0 : firstItem.element) == null ? void 0 : _a.parentElement;

  while (parentElement && (lastItem == null ? void 0 : lastItem.element)) {
    var parent = parentElement;

    if (lastItem && parent.contains(lastItem.element)) {
      return parentElement;
    }

    parentElement = parentElement.parentElement;
  }

  return getDocument(parentElement).body;
}

function getPrivateStore(store) {
  return store == null ? void 0 : store.__unstablePrivateStore;
}

function createCollectionStore() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a;

  throwOnConflictingProps(props, props.store);
  var syncState = (_a = props.store) == null ? void 0 : _a.getState();
  var items = defaultValue(props.items, syncState == null ? void 0 : syncState.items, props.defaultItems, []);
  var itemsMap = new Map(items.map(function (item) {
    return [item.id, item];
  }));
  var initialState = {
    items: items,
    renderedItems: defaultValue(syncState == null ? void 0 : syncState.renderedItems, [])
  };
  var syncPrivateStore = getPrivateStore(props.store);
  var privateStore = createStore({
    items: items,
    renderedItems: initialState.renderedItems
  }, syncPrivateStore);
  var collection = createStore(initialState, props.store);

  var sortItems = function sortItems(renderedItems) {
    var sortedItems = sortBasedOnDOMPosition(renderedItems, function (i) {
      return i.element;
    });
    privateStore.setState("renderedItems", sortedItems);
    collection.setState("renderedItems", sortedItems);
  };

  setup(collection, function () {
    return init(privateStore);
  });
  setup(privateStore, function () {
    return batch(privateStore, ["items"], function (state) {
      collection.setState("items", state.items);
    });
  });
  setup(privateStore, function () {
    return batch(privateStore, ["renderedItems"], function (state) {
      var firstRun = true;
      var raf = requestAnimationFrame(function () {
        var _collection$getState = collection.getState(),
            renderedItems = _collection$getState.renderedItems;

        if (state.renderedItems === renderedItems) return;
        sortItems(state.renderedItems);
      });

      if (typeof IntersectionObserver !== "function") {
        return function () {
          return cancelAnimationFrame(raf);
        };
      }

      var ioCallback = function ioCallback() {
        if (firstRun) {
          firstRun = false;
          return;
        }

        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          return sortItems(state.renderedItems);
        });
      };

      var root = getCommonParent(state.renderedItems);
      var observer = new IntersectionObserver(ioCallback, {
        root: root
      });

      var _iterator = _createForOfIteratorHelper(state.renderedItems),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (!item.element) continue;
          observer.observe(item.element);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return function () {
        cancelAnimationFrame(raf);
        observer.disconnect();
      };
    });
  });

  var mergeItem = function mergeItem(item, setItems) {
    var canDeleteFromMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var prevItem;
    setItems(function (items2) {
      var index = items2.findIndex(function (_ref) {
        var id = _ref.id;
        return id === item.id;
      });
      var nextItems = items2.slice();

      if (index !== -1) {
        prevItem = items2[index];

        var nextItem = __spreadValues(__spreadValues({}, prevItem), item);

        nextItems[index] = nextItem;
        itemsMap.set(item.id, nextItem);
      } else {
        nextItems.push(item);
        itemsMap.set(item.id, item);
      }

      return nextItems;
    });

    var unmergeItem = function unmergeItem() {
      setItems(function (items2) {
        if (!prevItem) {
          if (canDeleteFromMap) {
            itemsMap.delete(item.id);
          }

          return items2.filter(function (_ref2) {
            var id = _ref2.id;
            return id !== item.id;
          });
        }

        var index = items2.findIndex(function (_ref3) {
          var id = _ref3.id;
          return id === item.id;
        });
        if (index === -1) return items2;
        var nextItems = items2.slice();
        nextItems[index] = prevItem;
        itemsMap.set(item.id, prevItem);
        return nextItems;
      });
    };

    return unmergeItem;
  };

  var registerItem = function registerItem(item) {
    return mergeItem(item, function (getItems) {
      return privateStore.setState("items", getItems);
    }, true);
  };

  return __spreadProps(__spreadValues({}, collection), {
    registerItem: registerItem,
    renderItem: function renderItem(item) {
      return chain(registerItem(item), mergeItem(item, function (getItems) {
        return privateStore.setState("renderedItems", getItems);
      }));
    },
    item: function item(id) {
      if (!id) return null;
      var item = itemsMap.get(id);

      if (!item) {
        var _privateStore$getStat = privateStore.getState(),
            items2 = _privateStore$getStat.items;

        item = items2.find(function (item2) {
          return item2.id === id;
        });

        if (item) {
          itemsMap.set(id, item);
        }
      }

      return item || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: privateStore
  });
}

export { createCollectionStore };